/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type ProfileWorkingPreferencesRendererQueryVariables = {
    orgRelayId: string;
    nonUserCalendarIds: Array<string | null>;
    userIds: Array<string | null>;
    teamHealthCalendarId: string;
};
export type ProfileWorkingPreferencesRendererQueryResponse = {
    readonly node: {
        readonly id: string;
        readonly " $fragmentRefs": FragmentRefs<"ProfileWorkingPreferences_org">;
    } | null;
};
export type ProfileWorkingPreferencesRendererQuery = {
    readonly response: ProfileWorkingPreferencesRendererQueryResponse;
    readonly variables: ProfileWorkingPreferencesRendererQueryVariables;
};



/*
query ProfileWorkingPreferencesRendererQuery(
  $orgRelayId: ID!
  $nonUserCalendarIds: [String]!
  $userIds: [String]!
  $teamHealthCalendarId: String!
) {
  node(id: $orgRelayId) {
    __typename
    id
    ... on Org {
      ...ProfileWorkingPreferences_org_MnShJ
    }
  }
}

fragment ProfileWorkingPreferences_org_MnShJ on Org {
  summarizedWorkingPreferences(calendarId: $teamHealthCalendarId) {
    busiestDay
    mostFocusTime
    mostBookedRoom
  }
  workingGroups(first: 1000000) {
    edges {
      node {
        rooms {
          roomId
          name
          id
        }
        id
      }
    }
  }
  meetingHoursQueryResult(userIds: $userIds, nonUserCalendarIds: $nonUserCalendarIds, resolveOverrides: false) {
    calendarMeetingHours(first: 1000000) {
      edges {
        node {
          id
          calendarId
          workingHours {
            timeZone
            type
            daySettings {
              day
              setting {
                minSlot
                maxSlot
                excludedSlots
              }
            }
            dayOverrides {
              date
              setting {
                minSlot
                maxSlot
                excludedSlots
              }
            }
            id
          }
        }
      }
    }
    userMeetingHours(first: 1000000) {
      edges {
        node {
          id
          workingHours {
            timeZone
            type
            daySettings {
              day
              setting {
                minSlot
                maxSlot
                excludedSlots
              }
            }
            dayOverrides {
              date
              setting {
                minSlot
                maxSlot
                excludedSlots
              }
            }
            id
          }
        }
      }
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "nonUserCalendarIds"
    } as any, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "orgRelayId"
    } as any, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "teamHealthCalendarId"
    } as any, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "userIds"
    } as any, v4 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "orgRelayId"
        } as any
    ], v5 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any, v6 = {
        "kind": "Variable",
        "name": "userIds",
        "variableName": "userIds"
    } as any, v7 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000000
        } as any
    ], v8 = {
        "alias": null,
        "args": null,
        "concreteType": "WorkingSetting",
        "kind": "LinkedField",
        "name": "setting",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "minSlot",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "maxSlot",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "excludedSlots",
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any, v9 = {
        "alias": null,
        "args": null,
        "concreteType": "WorkingHours",
        "kind": "LinkedField",
        "name": "workingHours",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "timeZone",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "type",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "DaySetting",
                "kind": "LinkedField",
                "name": "daySettings",
                "plural": true,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "day",
                        "storageKey": null
                    },
                    (v8 /*: any*/)
                ],
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "DayOverride",
                "kind": "LinkedField",
                "name": "dayOverrides",
                "plural": true,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "date",
                        "storageKey": null
                    },
                    (v8 /*: any*/)
                ],
                "storageKey": null
            },
            (v5 /*: any*/)
        ],
        "storageKey": null
    } as any;
    return {
        "fragment": {
            "argumentDefinitions": [
                (v0 /*: any*/),
                (v1 /*: any*/),
                (v2 /*: any*/),
                (v3 /*: any*/)
            ],
            "kind": "Fragment",
            "metadata": null,
            "name": "ProfileWorkingPreferencesRendererQuery",
            "selections": [
                {
                    "alias": null,
                    "args": (v4 /*: any*/),
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        (v5 /*: any*/),
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "calendarIds",
                                            "variableName": "nonUserCalendarIds"
                                        },
                                        {
                                            "kind": "Variable",
                                            "name": "teamHealthCalendarId",
                                            "variableName": "teamHealthCalendarId"
                                        },
                                        (v6 /*: any*/)
                                    ],
                                    "kind": "FragmentSpread",
                                    "name": "ProfileWorkingPreferences_org"
                                }
                            ],
                            "type": "Org",
                            "abstractKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                (v1 /*: any*/),
                (v0 /*: any*/),
                (v3 /*: any*/),
                (v2 /*: any*/)
            ],
            "kind": "Operation",
            "name": "ProfileWorkingPreferencesRendererQuery",
            "selections": [
                {
                    "alias": null,
                    "args": (v4 /*: any*/),
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "__typename",
                            "storageKey": null
                        },
                        (v5 /*: any*/),
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "alias": null,
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "calendarId",
                                            "variableName": "teamHealthCalendarId"
                                        }
                                    ],
                                    "concreteType": "SummarizedWorkingPreferences",
                                    "kind": "LinkedField",
                                    "name": "summarizedWorkingPreferences",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "busiestDay",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "mostFocusTime",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "mostBookedRoom",
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": (v7 /*: any*/),
                                    "concreteType": "WorkingGroupConnection",
                                    "kind": "LinkedField",
                                    "name": "workingGroups",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "WorkingGroupEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "WorkingGroup",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "Room",
                                                            "kind": "LinkedField",
                                                            "name": "rooms",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "roomId",
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "name",
                                                                    "storageKey": null
                                                                },
                                                                (v5 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        (v5 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": "workingGroups(first:1000000)"
                                },
                                {
                                    "alias": null,
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "nonUserCalendarIds",
                                            "variableName": "nonUserCalendarIds"
                                        },
                                        {
                                            "kind": "Literal",
                                            "name": "resolveOverrides",
                                            "value": false
                                        },
                                        (v6 /*: any*/)
                                    ],
                                    "concreteType": "MeetingHoursQueryResult",
                                    "kind": "LinkedField",
                                    "name": "meetingHoursQueryResult",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": (v7 /*: any*/),
                                            "concreteType": "CalendarMeetingHoursConnection",
                                            "kind": "LinkedField",
                                            "name": "calendarMeetingHours",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "CalendarMeetingHoursEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "CalendarMeetingHours",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                (v5 /*: any*/),
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "calendarId",
                                                                    "storageKey": null
                                                                },
                                                                (v9 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": "calendarMeetingHours(first:1000000)"
                                        },
                                        {
                                            "alias": null,
                                            "args": (v7 /*: any*/),
                                            "concreteType": "UserMeetingHoursConnection",
                                            "kind": "LinkedField",
                                            "name": "userMeetingHours",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "UserMeetingHoursEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "UserMeetingHours",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                (v5 /*: any*/),
                                                                (v9 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": "userMeetingHours(first:1000000)"
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "type": "Org",
                            "abstractKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "c6af346a97ab44c7336d90f16da68873",
            "id": null,
            "metadata": {},
            "name": "ProfileWorkingPreferencesRendererQuery",
            "operationKind": "query",
            "text": "query ProfileWorkingPreferencesRendererQuery(\n  $orgRelayId: ID!\n  $nonUserCalendarIds: [String]!\n  $userIds: [String]!\n  $teamHealthCalendarId: String!\n) {\n  node(id: $orgRelayId) {\n    __typename\n    id\n    ... on Org {\n      ...ProfileWorkingPreferences_org_MnShJ\n    }\n  }\n}\n\nfragment ProfileWorkingPreferences_org_MnShJ on Org {\n  summarizedWorkingPreferences(calendarId: $teamHealthCalendarId) {\n    busiestDay\n    mostFocusTime\n    mostBookedRoom\n  }\n  workingGroups(first: 1000000) {\n    edges {\n      node {\n        rooms {\n          roomId\n          name\n          id\n        }\n        id\n      }\n    }\n  }\n  meetingHoursQueryResult(userIds: $userIds, nonUserCalendarIds: $nonUserCalendarIds, resolveOverrides: false) {\n    calendarMeetingHours(first: 1000000) {\n      edges {\n        node {\n          id\n          calendarId\n          workingHours {\n            timeZone\n            type\n            daySettings {\n              day\n              setting {\n                minSlot\n                maxSlot\n                excludedSlots\n              }\n            }\n            dayOverrides {\n              date\n              setting {\n                minSlot\n                maxSlot\n                excludedSlots\n              }\n            }\n            id\n          }\n        }\n      }\n    }\n    userMeetingHours(first: 1000000) {\n      edges {\n        node {\n          id\n          workingHours {\n            timeZone\n            type\n            daySettings {\n              day\n              setting {\n                minSlot\n                maxSlot\n                excludedSlots\n              }\n            }\n            dayOverrides {\n              date\n              setting {\n                minSlot\n                maxSlot\n                excludedSlots\n              }\n            }\n            id\n          }\n        }\n      }\n    }\n  }\n}\n"
        }
    } as any;
})();
(node as any).hash = 'bceef8262d730e4be38b41a90536e1a1';
export default node;
